module.exports = __webpack_public_path__ + "static/media/desktop-cloud-alt.ef584d6b.svg";